// extracted by mini-css-extract-plugin
export default {"sortCatalogItems":"Sort_sortCatalogItems__+eFlJ","sortCatalogItem":"Sort_sortCatalogItem__Gi8r6","active":"Sort_active__nKbfN"};